export default class LocationRequest {
  constructor(rootNode) {
    this.data = {
      options: {
        enableHighAccuracy: true,
        timeout: 5000,
      },
    };

    this.$refs = {
      rootNode,
      locationTriggers: rootNode.querySelectorAll('.js-location'),
      geolocationRadio: rootNode.querySelector('.js-location-geo'),
      manlocationRadio: rootNode.querySelector('.js-location-manual'),
      zipInput: rootNode.querySelector('.zip-input'),
      countryInput: rootNode.querySelector('.country-input'),
      latitudeField: rootNode.querySelector('.location-lat'),
      longitudeField: rootNode.querySelector('.location-lng'),
      errorWrapper: rootNode.querySelector('.location-error'),
    };

    if ('geolocation' in navigator) this.setupWatcher();
    else this.errorCallback({code: '400', message: 'Navigator does not support.'});
  }

  setupWatcher() {
    this.$refs.locationTriggers.forEach(radioButton => {
      radioButton.addEventListener('change', e => {
        if ('geolocation' === e.target.value) {
          this.$refs.rootNode.classList.add('is-geo-loading');
          this.requestPosition();
        }else{
            this.resetInputFields();
        }
      });
    })
  }

  requestPosition() {
    navigator.geolocation.getCurrentPosition(this.successCallback.bind(this), this.errorCallback.bind(this), this.data.options);
  }

  resetInputFields() {
    this.$refs.zipInput.removeAttribute('disabled');
    this.$refs.countryInput.removeAttribute('disabled');
    this.$refs.rootNode.classList.remove('is-geo-loading');
  }

  successCallback({ coords }) {
    this.$refs.zipInput.setAttribute('disabled', 'disabled');
    this.$refs.countryInput.setAttribute('disabled', 'disabled');
    this.$refs.latitudeField.value = coords.latitude;
    this.$refs.longitudeField.value = coords.longitude;
    this.$refs.rootNode.classList.remove('is-geo-loading');
  }

  errorCallback(error) {
    this.$refs.errorWrapper.classList.add('is-visible');
    this.$refs.rootNode.classList.remove('is-geo-loading');
    this.$refs.geolocationRadio.classList.add('is-disabled');
    this.$refs.manlocationRadio.click();
    console.warn(`Location Denied(${error.code}): ${error.message}`);

    setTimeout(() => this.$refs.errorWrapper.classList.remove('is-visible'), 2500);
  }
}
